const initialState = {
  headers: [
    {
      title: 'Tenant Name',
      name: '__slot:renter',
      sortField: 'renter',
      titleClass: 'subtitle2',
      enabled: true
    },
    {
      title: 'Unit Number',
      name: 'unit_number',
      sortField: 'unit_number',
      titleClass: 'subtitle2',
      enabled: true
    },
    {
      title: 'Phone',
      sortField: 'cellphone',
      name: '__slot:cellphone',
      titleClass: 'subtitle2 expand',
      dataClass: 'expand',
      enabled: true
    },
    {
      title: 'Location',
      name: 'location_name',
      sortField: 'location_name',
      titleClass: 'subtitle2',
      enabled: true
    },
    {
      title: 'Status',
      sortField: 'status',
      name: '__slot:formatStatusSlot',
      titleClass: 'subtitle2 expand',
      dataClass: 'expand',
      enabled: true
    },
    {
      title: 'Previous stage',
      name: 'previous',
      sortField: 'previous',
      titleClass: 'subtitle2',
      callback: 'formatPreviousStage',
      enabled: true
    },
    {
      title: 'Next stage',
      name: 'next',
      sortField: 'next',
      titleClass: 'subtitle2',
      callback: 'formatPreviousStage',
      enabled: true
    },
    {
      title: 'Step Delay',
      name: '__slot:overdue',
      sortField: 'next_execution_date',
      titleClass: 'subtitle2 expand',
      callback: 'formatOverdue',
      dataClass: 'expand',
      enabled: true,
      adminOnly: true
    },
    {
      title: 'Past Due',
      name: '__slot:delay',
      sortField: 'next_due_date',
      titleClass: 'subtitle2 expand',
      dataClass: 'expand',
      enabled: true
    },
    {
      title: 'Due amount',
      name: 'due_amount',
      sortField: 'due_amount',
      callback: 'formatCurrency',
      titleClass: 'subtitle2 expand',
      dataClass: 'expand has-text-right',
      enabled: true
    },
    {
      title: 'Auction end date',
      name: 'auction_end',
      sortField: 'auction_end',
      titleClass: 'subtitle2 expand',
      dataClass: 'expand',
      enabled: true
    },
    {
      title: 'Holds #',
      name: 'count_holds',
      sortField: 'count_holds',
      titleClass: 'subtitle2 expand',
      dataClass: 'expand',
      enabled: true
    },
    {
      title: 'Restarts #',
      name: 'count_restarts',
      sortField: 'count_restarts',
      titleClass: 'subtitle2 expand',
      dataClass: 'expand',
      enabled: true
    }
  ],
  filters: {}
};

const getters = {
  getDashboardTableOptions: (state) => (adminOnly = false) => (adminOnly ? state.headers.filter((header) => !header.adminOnly) : state.headers),
  getDashboardTableHeaders: (state) => (adminOnly = false) => ((adminOnly ? state.headers.filter((header) => !header.adminOnly) : state.headers))
    .filter((header) => header.enabled),
  getDashboardTableFilters: (state) => state.filters
};

const actions = {};

const mutations = {
  setInitHeaders: (state) => {
    const storageHeaders = localStorage.getItem('dashboard.tableHeaders');
    const savedHeaders = storageHeaders ? JSON.parse(storageHeaders) : null;

    if (savedHeaders) {
      state.headers = savedHeaders;
    }
  },
  setInitFilters: (state) => {
    const storageFilters = localStorage.getItem('dashboard.tableFilters');
    const savedFilters = storageFilters ? JSON.parse(storageFilters) : null;

    if (savedFilters) {
      state.filters = savedFilters;
    }
  },
  setDashboardTableHeaders: (state, headers) => {
    localStorage.setItem('dashboard.tableHeaders', JSON.stringify(headers));
    state.headers = headers;
  },
  setDashboardTableFilters: (state, filters) => {
    localStorage.setItem('dashboard.tableFilters', JSON.stringify(filters));
    state.filters = filters;
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
